<template>
  <router-view></router-view>

  <LockscreenOverlay ref="lockscreenRef" :key="lockscreenKey" :timeout="lockscreenTimeout"
    :countdownDuration="lockscreenCountdown" message="Ecran verrouillé"
    subMessage="Veuillez vous réauthentifier pour continuer" :blurStrength="10" @locked="handleLocked"
    @unlocked="handleUnlocked" />
</template>

<script>
import LockscreenOverlay from '@/components/lockscreenOverlay.vue';
import { EventBus } from '@/utils/eventBus';

export default {
  name: 'App',
  components: {
    LockscreenOverlay,
  },
  data() {
    return {
      lockscreenRef: null,
      lockscreenKey: 0,
      lockscreenTimeout: parseInt(localStorage.getItem('lockscreen_timeout')) || 1200000,
      lockscreenCountdown: parseInt(localStorage.getItem('lockscreen_countdown')) || 300000,
      lockscreenTimeoutMinutes: parseInt(localStorage.getItem('lockscreen_timeout_minutes')) || 20,
      lockscreenCountdownMinutes: parseInt(localStorage.getItem('lockscreen_countdown_minutes')) || 5
    };
  },
  provide() {
    return {
      lockscreen: () => this.lockscreenRef
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.lockscreenRef = this.$refs.lockscreenRef;
    });

    // Utiliser l'EventBus
    EventBus.$on('lockscreen-settings-changed', (data) => {
      console.log('🟢 App.vue reçoit nouvelles données:', data);

      this.lockscreenTimeout = data.timeoutMs;
      this.lockscreenCountdown = data.countdownMs;
      this.lockscreenTimeoutMinutes = data.timeoutMinutes;
      this.lockscreenCountdownMinutes = data.countdownMinutes;

      localStorage.setItem('lockscreen_timeout', data.timeoutMs);
      localStorage.setItem('lockscreen_countdown', data.countdownMs);

      if (this.lockscreenRef && this.lockscreenRef.resetWithNewSettings) {
        console.log('Appel resetWithNewSettings');
        this.lockscreenRef.resetWithNewSettings(data.timeoutMs, data.countdownMs);
      }

      this.lockscreenKey++;
    });
  },
  beforeUnmount() {
    EventBus.$off('lockscreen-settings-changed');
  },
  methods: {
    handleLocked() {
      console.log('Écran verrouillé');
    },
    handleUnlocked() {
      console.log('Écran déverrouillé');
    }
  }
}
</script>

<style>
.text-bordeaux {
  color: #800000 !important;
}

/* Variables de couleurs */
:root {
  --vz-primary: #405189;
  --vz-primary-subtle: #e7ebf5;
  --vz-success: #0ab39c;
  --vz-success-subtle: #e0f5f1;
  --vz-danger: #f06548;
  --vz-danger-subtle: #fde9e7;
  --vz-warning: #f7b84b;
  --vz-warning-subtle: #fef3e5;
  --vz-info: #299cdb;
  --vz-info-subtle: #e3f0fa;
  --vz-light: #f3f6f9;
  --vz-dark: #1e293b;
  --vz-muted: #7e8794;
  --vz-card-bg: #ffffff;
  --vz-border-color: #e9ebec;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-enter-active {
  animation: fadeIn 0.3s ease;
}

/* Scrollbar personnalisée */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: var(--vz-light);
}

::-webkit-scrollbar-thumb {
  background: var(--vz-muted);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--vz-primary);
}

/* Utilitaires */
.text-purple {
  color: #7f56da;
}

.bg-purple-subtle {
  background: #f2edff;
  color: #7f56da;
}

/* Transitions */
.folder-enter-active,
.folder-leave-active {
  transition: all 0.3s ease;
}

.folder-enter-from,
.folder-leave-to {
  opacity: 0;
  transform: scale(0.9);
}
</style>